<div class="trd-container">
  <div class="trd-header">
    <h2>Validation Template Result</h2>
    <span class="trd-tally">
      <span class="trd-pass-tally">{{ passCount }} passed</span>
      <span class="trd-fail-tally" *ngIf="failCount > 0">{{ failCount }} failed</span>
    </span>
  </div>

  <div mat-dialog-content class="trd-content">
    <p class="trd-summary" *ngIf="summary">{{ summary }}</p>

    <!-- Shared per-check row rendering -- used both for ungrouped top-level
         rows and for each row inside an array-loop element's <details>
         section below, so styling only needs to exist once. -->
    <ng-template #rowTpl let-row="row" let-displayPath="displayPath">
      <div
        class="trd-row"
        [ngClass]="{ 'trd-row-fail': !row.passed && !row.isVerifyOnly, 'trd-row-verify-fail': !row.passed && row.isVerifyOnly }"
      >
        <mat-icon
          class="trd-icon"
          [ngClass]="row.passed ? 'trd-icon-pass' : (row.isVerifyOnly ? 'trd-icon-verify-fail' : 'trd-icon-fail')"
        >
          {{ row.passed ? 'check_circle' : (row.isVerifyOnly ? 'warning' : 'cancel') }}
        </mat-icon>
        <div class="trd-row-text">
          <span class="trd-path">
            {{ displayPath }}
            <em class="trd-verify-badge" *ngIf="!row.passed && row.isVerifyOnly">verification failed</em>
          </span>
          <span
            class="trd-detail"
            [ngClass]="{ 'trd-detail-pass': row.passed, 'trd-detail-verify-fail': !row.passed && row.isVerifyOnly }"
            *ngIf="row.detail"
          >{{ row.detail }}</span>
        </div>
      </div>
    </ng-template>

    <!-- Nothing failed -- one banner instead of a long list of green rows;
         a passed check needs no attention, so there's nothing worth
         scanning through here. -->
    <div class="trd-all-passed" *ngIf="allPassed">
      <mat-icon class="trd-icon-pass">check_circle</mat-icon>
      <span>All checks passed</span>
    </div>

    <ng-container *ngIf="!allPassed">
      <!-- A plain top-level field (not part of any array-loop check) that
           failed -- rendered as a single row, same as before grouping. -->
      <ng-container *ngFor="let row of standaloneRows">
        <ng-container *ngTemplateOutlet="rowTpl; context: { row: row, displayPath: row.path }"></ng-container>
      </ng-container>

      <!-- One array-loop check's failures, broken down field-first: which
           field, then that field's failing result across every index. Only
           failing entries reach this list, so every group here has at least
           one and is shown expanded. -->
      <details class="trd-group" *ngFor="let group of arrayGroups" open>
        <summary class="trd-group-summary">
          <span class="trd-group-label">{{ group.arrayPath }}</span>
          <span class="trd-group-tally">{{ arrayGroupFailCount(group) }} failed</span>
        </summary>
        <div class="trd-field-group" *ngFor="let fg of group.fieldGroups">
          <div class="trd-field-group-label">{{ fg.fieldLabel }}</div>
          <ng-container *ngFor="let entry of fg.entries">
            <ng-container *ngTemplateOutlet="rowTpl; context: { row: entry.row, displayPath: entry.indexLabel }"></ng-container>
          </ng-container>
        </div>
      </details>
    </ng-container>

    <p class="trd-empty" *ngIf="rows.length === 0">No parseable check results in this message.</p>
  </div>

  <div mat-dialog-actions class="trd-actions">
    <button mat-raised-button color="primary" (click)="close()">
      <mat-icon>close</mat-icon> <span>Close</span>
    </button>
  </div>
</div>
